import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Camera, Loader2, Trash2 } from "lucide-react";
import { clientPhotoUrl, deleteClientPhoto, uploadClientPhoto } from "@/lib/bf";

const Thumb = ({ id, p, onDel }) => {
  const [src, setSrc] = useState("");
  useEffect(() => { let u = ""; clientPhotoUrl(id, p.id).then((x) => { u = x; setSrc(x); }).catch(() => {}); return () => u && URL.revokeObjectURL(u); }, [id, p.id]);
  return (
    <li data-testid={`bfc-photo-${p.id}`}>
      {src ? <a href={src} target="_blank" rel="noopener noreferrer"><img src={src} alt="Poză salon" /></a> : <span className="bfc-ph-load"><Loader2 size={16} className="animate-spin" /></span>}
      <button type="button" onClick={() => onDel(p)} aria-label="Șterge poza" data-testid={`bfc-photo-del-${p.id}`}><Trash2 size={13} /></button>
    </li>
  );
};

export default function BFClientPhotos({ id, photos, setPhotos }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const up = async (files) => {
    setBusy(true);
    for (const f of [...files]) { // eslint-disable-next-line no-await-in-loop
      await uploadClientPhoto(id, f).then((d) => setPhotos((l) => [d, ...l])).catch((e) => toast.error(e.response?.data?.detail || `Nu am putut încărca ${f.name}`));
    }
    setBusy(false);
    if (ref.current) ref.current.value = "";
  };
  const del = (p) => deleteClientPhoto(id, p.id).then(() => setPhotos((l) => l.filter((x) => x.id !== p.id))).catch(() => toast.error("Nu am putut șterge poza"));
  return (
    <section className="invite-box bfc-sec" data-testid="bfc-photos">
      <h3><Camera size={16} /> Poze din salon</h3>
      <input ref={ref} type="file" accept="image/*" multiple hidden onChange={(e) => e.target.files?.length && up(e.target.files)} data-testid="bfc-photo-input" />
      <button type="button" className="st-btn st-btn--light" onClick={() => ref.current?.click()} disabled={busy} data-testid="bfc-photo-add">{busy ? <Loader2 size={14} className="animate-spin" /> : <Camera size={14} />} Adaugă poze (raft, vitrină, salon)</button>
      {!photos.length && <p className="st-hint">Nicio poză încă.</p>}
      <ul className="bfc-photos">{photos.map((p) => <Thumb key={p.id} id={id} p={p} onDel={del} />)}</ul>
    </section>
  );
}
